import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45e91a17"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "field is-grouped" }
const _hoisted_2 = { class: "control" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: undefined,
  disabled: "",
  selected: ""
}, "Layer type", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "group", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "transfo-svg", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "text", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "image", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "html", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", null, "external-spread", -1))
const _hoisted_10 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5,
  _hoisted_6,
  _hoisted_7,
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "control" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus" }, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "control" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "control" }
const _hoisted_18 = { class: "control" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("select", {
        class: "select is-small",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.addingLayer = $event))
      }, _hoisted_10, 512), [
        [_vModelSelect, _ctx.addingLayer]
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("button", {
        class: "button is-small",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.add()))
      }, _hoisted_13)
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("button", {
        class: "button is-small",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.remove()))
      }, _hoisted_16)
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("button", {
        class: "button is-small",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.toggleSelectParent()))
      }, "Select " + _toDisplayString(_ctx.parentType), 1)
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("button", {
        class: "button is-small",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectView()))
      }, "Select view")
    ])
  ]))
}